import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/messaging/_layout/')({
  component: Inbox,
})

function Inbox() {
  // This is intentional
  return <></>
}
